"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function () {
        GState.bind(this, ['tenant']);
    },
    onChange: function (id) {
        if (!Array.isArray(this.state.tenant.settings.navigation))
            this.state.tenant.settings.navigation = [];
        !this.state.tenant.settings.navigation.includes(id) ? this.state.tenant.settings.navigation.push(id) : this.state.tenant.settings.navigation = this.state.tenant.settings.navigation.filter(each => {
            return each != id;
        });
        this.setStateDirty('tenant');
        GState.tenant.update({ 'navigation': this.state.tenant.settings.navigation }, 'settings');
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Settings/Admin/sections/Navigation/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_Features = require("./features.json"),
    Features = module_Features.default || module_Features,
    Locale_template = require("../../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    Row_template = require("../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    marko_attrs0 = {
        "class": "font-medium-2 mb-4"
      },
    marko_attrs1 = {
        "class": "form-group"
      },
    marko_attrs2 = {
        "class": "form-group my-1"
      },
    marko_attrs3 = {
        "class": "checkbox checkbox-secondary"
      };

function render(input, out, __component, component, state) {
  var data = input;

  Row_tag({
      col: [
          {
              renderBody: function(out) {
                out.be("section", null, "2", component);

                out.be("p", marko_attrs0, "3", component);

                Locale_tag({
                    renderBody: function(out) {
                      out.t("Select features/services to display on admin navigation dashboard");
                    }
                  }, out, __component, "4");

                out.ee();

                out.be("div", marko_attrs1, "5", component);

                var $for$0 = 0;

                marko_forOf(Features, function({ id, title, label, mandatory, disabled }, index) {
                  var $keyScope$0 = "[" + (($for$0++) + "]");

                  if (!mandatory) {
                    out.be("div", marko_attrs2, "@" + index, component);

                    out.be("div", marko_attrs3, "6" + $keyScope$0, component);

                    out.e("input", {
                        type: "checkbox",
                        id: id,
                        disabled: disabled,
                        checked: ((state.tenant && state.tenant.settings) && Array.isArray(state.tenant.settings.navigation)) && state.tenant.settings.navigation.includes(id)
                      }, "7" + $keyScope$0, component, 0, 0, {
                        onchange: __component.d("change", "onChange", false, [
                            id
                          ])
                      });

                    out.be("label", {
                        "for": id,
                        "class": "font-medium-1"
                      }, "8" + $keyScope$0, component);

                    Locale_tag({
                        text: title
                      }, out, __component, "9" + $keyScope$0);

                    if (label) {
                      out.e("br", null, "10" + $keyScope$0, component, 0);

                      Locale_tag({
                          text: label,
                          class: "font-small-3 text-muted"
                        }, out, __component, "11" + $keyScope$0);
                    }

                    out.ee();

                    out.ee();

                    out.ee();
                  }
                });

                out.ee();

                out.ee();
              }
            }
        ]
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
